// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../../types';
import { SEMIBOLD } from '../../../../../helpers/fontWeight';

type Props = {
  active: boolean,
};

export default styled<any, Theme, Props>('h3')`
  color: ${props => (props.active ? props.theme.optionPrice.titleColor.active : props.theme.optionPrice.titleColor.normal)};
  font-size: ${props => props.theme.optionPriceExtended.title.fontSize};
  font-weight: ${SEMIBOLD};
  margin-bottom: .5rem;
`;
